import React, { useEffect } from "react";
import moment from "moment";

const BarComponent = ({ datumres, ervaring, boekingen }) => {

  const telreserveringen = () => {
    return ervaring.ervaringdatums.reduce((reserveringen, datum) => {
      return reserveringen + datum.aantalreserveringen;
    }, 0);
  };

  const aantalpersonen = () => {
    return ervaring.ervaringdatums.reduce((reserveringen, datum) => {
      return reserveringen + datum.aantalpersonen;
    }, 0);
  };
  

  return (
    <div className="barback mb-3" style={{padding: '18px'}}>
      {/* Clean single row layout */}
      <div className="row g-3">
        <div className="col-md-3 col-6">
          <div className="info-box bg-info text-white" style={{minHeight: '85px', padding: '15px', marginBottom: '10px'}}>
            <span className="info-box-icon" style={{width: '55px', height: '55px', fontSize: '24px'}}>
              <i className="fa-solid fa-list-check"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text" style={{fontSize: '11px', marginBottom: '4px'}}>RESERVERINGEN</span>
              <span className="info-box-number" style={{fontSize: '20px', fontWeight: '700'}}>{telreserveringen()}</span>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="info-box bg-success text-white" style={{minHeight: '85px', padding: '15px', marginBottom: '10px'}}>
            <span className="info-box-icon" style={{width: '55px', height: '55px', fontSize: '24px'}}>
              <i className="fa fa-users"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text" style={{fontSize: '11px', marginBottom: '4px'}}>PERSONEN</span>
              <span className="info-box-number" style={{fontSize: '20px', fontWeight: '700'}}>{aantalpersonen()}</span>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="info-box bg-warning text-dark" style={{minHeight: '85px', padding: '15px', marginBottom: '10px'}}>
            <span className="info-box-icon text-dark" style={{width: '55px', height: '55px', fontSize: '24px'}}>
              <i className="fa-solid fa-user-lock"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text" style={{fontSize: '11px', marginBottom: '4px'}}>MAX PERSONEN</span>
              <span className="info-box-number" style={{fontSize: '20px', fontWeight: '700'}}>{ervaring?.beschikbaarheid?.personenmax}</span>
            </div>
          </div>
        </div>
        <div className="col-md-3 col-6">
          <div className="info-box bg-secondary text-white" style={{minHeight: '85px', padding: '15px', marginBottom: '10px'}}>
            <span className="info-box-icon" style={{width: '55px', height: '55px', fontSize: '24px'}}>
              <i className="fa-solid fa-user-clock"></i>
            </span>
            <div className="info-box-content">
              <span className="info-box-text" style={{fontSize: '11px', marginBottom: '4px'}}>MIN PERSONEN</span>
              <span className="info-box-number" style={{fontSize: '20px', fontWeight: '700'}}>{ervaring?.beschikbaarheid?.personenmin}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarComponent;
